export default [
  {
    name: 'currentVolume',
    label: 'current_volume_in',
    type: 'number',
    default: {
      comparison: 'more',
    },
  },
]
